<template>
    <div class="container" style="margin-bottom: 15px;">
        <img class="img" :src="worksItem.cover" alt="">
        <div class="article-info">
            <div class="articleDesc" >
              
                  <div style="padding:10px 0 0 0px;color:#BBBBBB;">
                      <span class="iconfont" style="margin-right:4px;vertical-align: middle">&#xe636;</span>
                      <span class="iconStyle" v-if="worksItem.status==0">审核中</span>
                      <span class="iconStyle" v-if="worksItem.status==1">{{ worksItem.updateTime }}</span>
                      <span class="iconStyle" v-if="worksItem.status==2" style="color: red" :title="worksItem.checkSuggest">未通过</span>
                      <span class="iconStyle" v-if="worksItem.status==3">下架</span>
                      <span class="iconStyle" v-if="worksItem.status==4">草稿</span>

                      <span v-if="linkFrom !='space'">
                        <span @click="deleteWorks(worksItem.id)">
                          <span class="iconfont" style="margin:0 4px 0 5px;vertical-align: middle">&#xe61e;</span>
                          <span class="iconStyle">删除</span>
                        </span>
                        <span @click="editWorks(worksItem.id)">
                          <span class="iconfont" style="margin:0 4px 0 5px;vertical-align: middle">&#xe690;</span>
                          <span class="iconStyle">编辑</span>
                        </span>
                      </span>
                  </div>
             </div>
        </div>
    </div>
</template>
<script>
import {delWork} from "@/comm/api";

export default {
  name: 'ManagerArticleV',
  components: {

  },
  props: {
    worksItem:{},
    collection:{
      type:Boolean,
      default:false,
    },
    linkFrom:{
      type:String,
      default:'',
    }

  },
  data() {
    return {

    }
  },
  methods:{
    async deleteWorks(id){
      await delWork({id:id});
      this.$emit("submit-loadPage");
      this.$message.success('删除成功');
    },
    editWorks(id){
      let routeData = this.$router.resolve({ path: '/creativeCenter', query: {"viewKey": "4-3","resourceId":id } });
      window.open(routeData.href, '_blank');
    }
  }
}
</script>
<style lang="stylus" scoped>
    .container
        width 96%;
        height 100%;
        // background white;
        border-radius 4px;
        cursor pointer;
        padding:10px 0 0px 0;

        .flex-center
            display flex;
            align-items center;
        .img
            width 100%;
            height 100%;
            border-radius 4px ;
        .article-info
            margin-top:-5px;
            // padding:15px 10px;
            // background :#f4f4f5;
            .title
                font-size: 14px;
                font-weight: 400;
                color: #999999;
                line-height: 20px;
                text-align:left;
            .articleDesc

                font-weight: 400;
                color: #B8B9BA;
                line-height: 17px;
                margin-top 8px;
                text-align :left;
                .iconStyle{
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #BBBBBB;
                    line-height: 17px;

                }
.toolDiv{
    background: #fff;
    padding-bottom:15px;
    margin-top:10px;
    background :#f4f4f5;
    width:100%;
    .tool{
        padding-right:3px;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #b8b9ba;
        line-height: 20px;
        height :20px;
    }
}
</style>
